import { render, staticRenderFns } from "./CustomerFb.vue?vue&type=template&id=36aa54d0&"
import script from "./CustomerFb.vue?vue&type=script&lang=js&"
export * from "./CustomerFb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports